import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import React from 'react';

import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { useModalActions } from '@store/useModalStore';

import ModalHeader from '../ModalHeader/ModalHeader';
import type { IOilReport } from './model/IOilReport';
import style from './style.module.scss';

interface IProps {
  reports: Array<IOilReport>;
}

const OilReportModal: React.FC<IProps> = ({ reports }) => {
  const { t } = useTranslation();

  const { data: profileData } = useUserProfileQuery();
  const currentDateFormat = `${profileData?.dateFormat.date} ${profileData?.dateFormat.time}`;

  const { setModalClose } = useModalActions();

  const handleClose = () => {
    setModalClose();
  };

  const handleSaveOilReport = (report: IOilReport) => {
    saveAs(report.url, `${report.installation_point_name} ${format(new Date(), currentDateFormat)}.pdf`);
  };

  return (
    <div className={style.oilReportModal}>
      <ModalHeader onClose={handleClose} />
      <div className={style.modalBody}>
        <div className={style.modalBodyTitle}>{t('Oil Analysis Reports')}</div>
        <div className={style.reportsWrapper}>
          {reports.map((report) => (
            <div key={report.id} className={style.reportItem}>
              <div className={style.reportItemName}>
                {report.installation_point_name}
                <span className={style.reportItemDate}>{format(report.created_at, currentDateFormat)}</span>
              </div>
              <Button type="secondary" text={t('Open report')} onClick={() => handleSaveOilReport(report)} />
            </div>
          ))}
        </div>
      </div>
      <div className={style.modalFooter}>
        <Button type="primary" text={t('Close')} onClick={handleClose} />
      </div>
    </div>
  );
};

export default OilReportModal;
